export default {
  SHOW_SND_FEATURES_FOR_PAID_ORGS: [
    '63d9db4aa8dbfd0301f5485d',
    '60919f6b27f749001c9a4bd7',
    '62c859259a7482fceecb7bb5',
  ],

  SHOW_ADMIN_DASHBOARD_FOR_PAID_ORGS: [
    '63d9db4aa8dbfd0301f5485d',
    '60919f6b27f749001c9a4bd7',
    '64c3a99865f80743e22c65a0',
  ],
};
